import React, { Fragment } from 'react';
import {
  Grid,
  Header,
  Form,
  Button,
  Divider,
  Icon,
  Accordion,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { DatePickerCustomButton } from 'Components';
import ReactTable from 'Common/ReactTableWrapper';
import { DatePickerField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { TransferOrderEnum } from 'Common/FieldEnum';
import { TRANSFER_ORDER_FORM_NAME } from 'Common/FormEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { SiteComponent } from 'Common/SiteComponent';

const TransferOrder = props => {
  const printOptions = [
    { value: TransferOrderEnum.ItemCode, label: 'Item Code' },
    { value: TransferOrderEnum.ItemDescription, label: 'Item Description' },
  ];
  const {
    columns,
    reactTableRef,
    transferOrderListData,
    loading,
    fetchingSites,
    gridPreferenceLoading,
    gridPreferenceSubmitting,
    fromDateMax,
    toDateMin,
    onChangeOfFromDT,
    onChangeOfToDT,
    setSelectedSite,
    clearFilters,
    printTransfers,
    activeIndexForFilter,
    handleClick,
    activeIndexForSort,
    siteValue,
  } = props;

  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            option={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <Grid.Row columns={2}>
                <Grid.Column width={8}>
                  <div style={{ paddingTop: '25px' }}>
                    <Header as="h4">Date Range</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'From:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={TransferOrderEnum.BeginDT}
                    onChange={onChangeOfFromDT}
                    maxDate={fromDateMax}
                    type={'text'}
                    dropdownMode="select"
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'To:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={TransferOrderEnum.EndDT}
                    type={'text'}
                    onChange={onChangeOfToDT}
                    minDate={toDateMin}
                    dropdownMode="select"
                  />
                </Grid.Column>
                <Grid.Column>
                  <SiteComponent
                    name={TransferOrderEnum.Site}
                    label={TransferOrderEnum.Site}
                    {...this.props}
                    isForm={true}
                    isAllRequired={true}
                    showAllActiveSites={true}
                    selectFirst={true}
                    onChange={setSelectedSite}
                    selected={siteValue}
                  />
                </Grid.Column>
                <Grid.Column
                  style={{ marginTop: '45px' }}
                  floated={'right'}
                  textAlign={'right'}
                >
                  <Button
                    content="Clear Filters"
                    onClick={e => clearFilters()}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
          <Accordion.Title
            active={!activeIndexForSort}
            index={0}
            option={1}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Sort By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForSort}>
            <Grid>
              <Grid.Row columns={2} className={'pt10'}>
                <Grid.Column verticalAlign={'bottom'}>
                  <ReduxFormButtonGroup
                    options={printOptions}
                    formName={TRANSFER_ORDER_FORM_NAME}
                    fieldName={TransferOrderEnum.PrintOptions}
                    type={'button'}
                  />
                </Grid.Column>
                <Grid.Column floated={'right'} textAlign={'right'}>
                  <Button
                    disabled={loading}
                    content="Print Transfer(s)"
                    type={'button'}
                    style={{ marginLeft: 10 }}
                    onClick={printTransfers}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <ReactTable
                reactTableRef={reactTableRef}
                defaultPageSize={20}
                showPageSizeOptions={true}
                minRows={0}
                data={transferOrderListData || []}
                noDatatext={loading ? '' : 'No rows found'}
                resizable={false}
                loadingText={loading ? 'Loading...' : ''}
                className="-striped -highlight modalGrid"
                columns={columns}
                loading={
                  loading ||
                  fetchingSites ||
                  gridPreferenceLoading ||
                  gridPreferenceSubmitting
                }
                draggableColumns={true}
                showHideColumn={true}
                menu={'hasCogs'}
                saveState={{
                  tableName: TableNamesEnum.TRANSFER_ORDER_TABLE,
                }}
                hasSelectAllColumn={true}
                gridName={GridEnum.INV_TransferOrder_View}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

TransferOrder.propTypes = {
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  setSelectedSite: PropTypes.func,
  clearFilters: PropTypes.func,
  printTransfers: PropTypes.func,
  handleClick: PropTypes.func,
  activeIndexForFilter: PropTypes.number,
  activeIndexForSort: PropTypes.number,

  fromDateMax: PropTypes.object,
  toDateMin: PropTypes.object,
  siteValue: PropTypes.string,
  loading: PropTypes.bool,
  fetchingSites: PropTypes.bool,
  gridPreferenceLoading: PropTypes.bool,
  gridPreferenceSubmitting: PropTypes.bool,
  reactTableRef: PropTypes.object,
  columns: PropTypes.array.isRequired,
  transferOrderListData: PropTypes.array.isRequired,
};
TransferOrder.defaultProps = {
  reactTableRef: null,
  loading: false,
  fetchingSites: false,
  gridPreferenceLoading: false,
  gridPreferenceSubmitting: false,
  fromDateMax: null,
  toDateMin: null,
  siteValue: '',
  onChangeOfFromDT: () => {},
  onChangeOfToDT: () => {},
  setSelectedSite: () => {},
  clearFilters: () => {},
  printTransfers: () => {},
  handleClick: () => {},
  activeIndexForFilter: 0,
  activeIndexForSort: 1,
};
export default TransferOrder;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/components/TransferOrderList/TransferOrder.js